import React from "react";
import { useI18n } from "../lib/i18n";
import { SectionEyebrow } from "../components/common/Section";
import { resolveImage } from "../components/admin/ImageUpload";

/** Reusable large hero banner for internal pages. */
const PageHero = ({ eyebrow, title, subtitle, image }) => {
  const { pick } = useI18n();
  const bg = resolveImage(image) || "https://images.unsplash.com/photo-1481026469463-66327c86e544";
  return (
    <section
      className="relative h-[64vh] min-h-[420px] hero-backdrop grain overflow-hidden flex items-end"
      data-testid="page-hero"
    >
      <img src={bg} alt="" className="absolute inset-0 w-full h-full object-cover" aria-hidden="true" />
      <div className="relative z-10 container-x pb-16 md:pb-20 w-full text-white">
        {eyebrow ? <SectionEyebrow className="text-white/70">{eyebrow}</SectionEyebrow> : null}
        <h1
          className="display display-lg mt-6 text-white max-w-4xl"
          style={{ whiteSpace: "pre-line", color: "#ffffff" }}
          data-testid="page-hero-title"
        >
          {typeof title === "string" ? title : pick(title, "")}
        </h1>
        {subtitle ? (
          <p className="mt-6 text-white/75 max-w-2xl leading-relaxed">
            {typeof subtitle === "string" ? subtitle : pick(subtitle, "")}
          </p>
        ) : null}
      </div>
    </section>
  );
};

export default PageHero;
